import { ProjectBase } from './base/project-base';

export class Project extends ProjectBase {
  ScheduleTemplateNameId: number | null;
}